var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconVisa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0054A4",
  d: "M20 15c0 .736-.597 1.333-1.333 1.333H1.333A1.333 1.333 0 0 1 0 15V4.333C0 3.597.597 3 1.333 3h17.334C19.403 3 20 3.597 20 4.333z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m7.843 12.02.755-4.314h1.206l-.755 4.314zM12.941 7.881a2.5 2.5 0 0 0-.937-.175c-1.033 0-1.761.567-1.767 1.379-.007.6.52.936.916 1.135.407.205.544.336.542.519-.003.28-.325.408-.626.408-.418 0-.64-.063-.984-.219l-.135-.066-.146.935c.244.116.696.217 1.165.223 1.098 0 1.812-.56 1.82-1.428.004-.476-.274-.837-.878-1.135-.365-.194-.59-.322-.587-.519 0-.173.19-.36.6-.36.341-.005.589.077.782.161l.094.048z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M15.979 7.706h-.844c-.262 0-.457.076-.572.358L12.94 12.02h1.147s.187-.532.23-.65l1.398.003c.033.15.133.647.133.647h1.014zm-1.347 2.782.435-1.207c-.006.012.09-.25.145-.412l.074.373.253 1.246z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.058 7.706 5.97 10.652l-.117-.6c-.203-.69-.833-1.437-1.54-1.812l.996 3.78 1.176-.001 1.75-4.313z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F39C12",
  d: "M4.974 7.706H3.152l-.015.09c1.418.358 2.356 1.223 2.745 2.263L5.486 8.07c-.068-.274-.266-.356-.512-.365"
}))));
export default SvgIconVisa;